//
//
//
//
//
//
//
//
//
//

import { defineComponent } from '@nuxtjs/composition-api';
import SfButton from "~/themes/fiskarsMoominDefault/components/components/atoms/SfButton/SfButton.vue";

export default defineComponent({
  name: 'SidebarEmptyButton',
  components: { SfButton },
  props: {
    buttonText: String
  }
});
